import { Renderer2 } from '@angular/core';

// Inserts a preconnect link element at the BEGINNING of the head element
const addPreloadLink = (document: Document, as: 'script' | 'style', href: string, crossOrigin = true): void => {
  const preloadTag = `<link rel="preload" as="${as}" href="${href}" ${crossOrigin ? 'crossorigin="anonymous"' : ''} >`;
  document.head.insertAdjacentHTML('afterbegin', preloadTag);
};

// Inserts a script element at the END of the element passed by parameter (head or body)
const addScript = (renderer: Renderer2, element: HTMLElement, src: string, defer = false, crossOrigin = true,
                   async = false): void => {
  const script: HTMLScriptElement = renderer.createElement('script');
  script.type = 'text/javascript';
  script.src = src;

  if (async) {
    script.async = true;
  }

  if (defer) {
    script.defer = true;
  }

  if (crossOrigin) {
    script.crossOrigin = 'anonymous';
  }

  element.insertAdjacentElement('beforeend', script);
};

// Inserts a stylesheet link element at the END of the head element
const addCSSLink = (renderer: Renderer2, document: Document, href: string, rel = 'stylesheet', type = 'text/css'): void => {
  const link: HTMLLinkElement = renderer.createElement('link');
  link.href = href;
  link.rel = rel;
  link.type = type;

  document.head.insertAdjacentElement('beforeend', link);
};

const htmlTagHelper = {
  addPreloadLink,
  addScript,
  addCSSLink,
};

export default htmlTagHelper;
